// extracted by mini-css-extract-plugin
module.exports = {"section":"HSection_section__EyaIx","content":"HSection_content__102uy"};